import React from 'react';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import theme from './PageTitleProjectName.module.scss';

interface PageTitleProjectNameProps {}

const PageTitleProjectName: React.FC<PageTitleProjectNameProps> = (props) => {
    const activeProject = useSelector((state: IState) => state.global.activeProject);
    return <span className={theme.title}>{activeProject?.name}</span>;
};
export default PageTitleProjectName;
